import { render, staticRenderFns } from "./OtherServiceOrderInvoiceEmailLogPopUp.vue?vue&type=template&id=71bbc652&scoped=true&"
import script from "./OtherServiceOrderInvoiceEmailLogPopUp.vue?vue&type=script&lang=js&"
export * from "./OtherServiceOrderInvoiceEmailLogPopUp.vue?vue&type=script&lang=js&"
import style0 from "./OtherServiceOrderInvoiceEmailLogPopUp.vue?vue&type=style&index=0&id=71bbc652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bbc652",
  null
  
)

export default component.exports